import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=507d5a7c&scoped=true&lang=pug"
import script from "./MessageAlert.vue?vue&type=script&lang=ts"
export * from "./MessageAlert.vue?vue&type=script&lang=ts"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=507d5a7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d5a7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507d5a7c')) {
      api.createRecord('507d5a7c', component.options)
    } else {
      api.reload('507d5a7c', component.options)
    }
    module.hot.accept("./MessageAlert.vue?vue&type=template&id=507d5a7c&scoped=true&lang=pug", function () {
      api.rerender('507d5a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert/CustomAlert/MessageAlert.vue"
export default component.exports